import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class TranslateDataService {
  private translationService = inject(TranslateService);

  translate(deString?: string, enString?: string): string {
    const currlang = this.translationService.currentLang;
    if (!deString && !enString) {
      return '';
    }
    if (currlang === 'de-DE' && deString) {
      return deString;
    }
    if (currlang === 'en-US' && enString) {
      return enString;
    }
    return '';
  }
}
